import type { FunctionComponent } from "react";
import { BrandInfoSliderMenuPartial } from "../../../../partials/admin/menus/brand/brand-info-slider-menu.admin.partials";

export const BrandInfoSliderMenuAdminScreen: FunctionComponent = () => {
	return <BrandInfoSliderMenuPartial />;
};
